const getProductList = (state) => { return state.productList }

const getAgents = (state) => { return state.agentsList }

const getCurrentAgent = (state) => { return state.currentAgent }

export default {
    getProductList,
    getAgents,
    getCurrentAgent,
}